import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'externalUrl',
})
export class ExternalUrlPipe implements PipeTransform {
  transform(url?: string | null): string {
    if (!url) {
      return '';
    }

    const normalizedUrl = url.trim();
    if (!normalizedUrl) {
      return '';
    }

    if (
      normalizedUrl.startsWith('/') ||
      normalizedUrl.startsWith('#') ||
      normalizedUrl.startsWith('./') ||
      normalizedUrl.startsWith('../') ||
      normalizedUrl.startsWith('?') ||
      normalizedUrl.startsWith('//')
    ) {
      return normalizedUrl;
    }

    if (/^[a-z][a-z0-9+.-]*:/i.test(normalizedUrl)) {
      return normalizedUrl;
    }

    return `https://${normalizedUrl}`;
  }
}
